import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SelectMenu } from '@livable/saas-react-components';
import { Button, MenuItem, Typography } from '@mui/material';
import { toJS } from 'mobx';
export const ModalContent = observer(_ref => {
  let utility = _ref.utility,
    onSaveAndClose = _ref.onSaveAndClose,
    onSaveAndCloseCustom = _ref.onSaveAndCloseCustom,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const effectiveUtilityId = (utility === null || utility === void 0 ? void 0 : utility.utilityId) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId);
  const pUtility = store.credentials.utilitiesGlSettings.find(i => i.utilityId === effectiveUtilityId);
  const _useState = useState(store.credentials.glAccounts),
    _useState2 = _slicedToArray(_useState, 2),
    utilityGlAccounts = _useState2[0],
    setUtilityGlAccounts = _useState2[1];
  const _useState3 = useState(pUtility !== null && pUtility !== void 0 && pUtility.glAccountExternalId ? pUtility === null || pUtility === void 0 ? void 0 : pUtility.glAccountExternalId : ''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  const handleGlSearch = v => {
    const currentArray = [];
    store.credentials.glAccounts.map(i => {
      if (i.name.toLocaleLowerCase().includes(v.trim().toLocaleLowerCase())) {
        currentArray.push(i);
      }
    });
    setUtilityGlAccounts(currentArray);
  };
  const handleChange = data => {
    if (effectiveUtilityId) {
      store.credentials.setUtilitiesGlSettings({
        glAccountExternalId: data,
        utilityId: effectiveUtilityId,
        propertyUtilityLivableId: null
      });
    }
    setUtilityGlAccounts(store.credentials.glAccounts);
    setValue(data);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('GL Account')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('Select the utility GL account.')), /*#__PURE__*/React.createElement("div", {
    className: classes.glAccount
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "gl-selector",
    enableSearch: true,
    labelId: "gl-selector-label",
    label: "Select utility GL account",
    disabled: store.credentials.glAccounts.length === 0,
    onSearch: handleGlSearch,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => handleChange(e.target.value),
    value: value,
    renderValue: selected => {
      var _utilityGlAccounts$fi;
      if (selected.length === 0) {
        return '';
      }
      return (_utilityGlAccounts$fi = utilityGlAccounts.find(item => item.externalId === selected)) === null || _utilityGlAccounts$fi === void 0 ? void 0 : _utilityGlAccounts$fi.name;
    }
  }, utilityGlAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number)))))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rightButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      if (onSaveAndClose) {
        onSaveAndClose({
          pUtility: toJS(pUtility),
          utility: toJS(utility),
          utilityGlAccounts: toJS(utilityGlAccounts),
          glAccountExternalId: value
        });
      }
      if (onSaveAndCloseCustom) onSaveAndCloseCustom(value);
      handleModalClose();
    },
    'custom-attribute': '168-gl-modal'
  }, t('add_new_property_flow.save_and_close')))));
});